export default __webpack_public_path__ + "static/media/close-icon.89604ce8.svg";